import * as React from 'react';
import { IPaymentEntryWrapperProps } from './PaymentEntryWrapper.properties';
import PaymentEntryDialog from '../PaymentEntryDialog';
import { ObjectifiedPaymentDetail, ObjectifiedPaymentDetailsResponse } from 'api/Worksale/payment';
import { processValidationForms } from 'utils/processValidationForms';
import { IPaymentDetailFacade, IProcessPaymentDetailsResponse } from 'api/swaggerTypes';
import { showSnackBar } from '../SnackBars/SnackBar.hooks';

function PaymentEntry(props: IPaymentEntryWrapperProps): JSX.Element {
  const { open, module, initialValues, onApply, onCancel, onAddNewPaymentLine, onCalculatePaymentLineDetails, onUpdatePaymentLineDetails, onDeletePaymentLine, changeConfirmationDialog, onCalculatePaymentAmount, onInitializePayment, onProcessPayment } = props;

  const [initialPaymentEntryValues, setInitialPaymentEntryValues] = React.useState<ObjectifiedPaymentDetail>();

  React.useEffect(
    () => {
      if (initialValues && open) {
        onInitializePaymentAndValidate(initialValues).then((response) => {
          if (response.Status && response?.PaymentDetail) {
            setInitialPaymentEntryValues(response?.PaymentDetail);
          }
        });
      }
    },
    [initialValues, open]
  );

  async function onProcessPaymentAndValidate(query: IPaymentDetailFacade): Promise<IProcessPaymentDetailsResponse> {
    return processValidationForms(await onProcessPayment(query), query, onProcessPaymentAndValidate);
  }

  async function onInitializePaymentAndValidate(query: any): Promise<ObjectifiedPaymentDetailsResponse> {
    return processValidationForms(await onInitializePayment(query), query, onInitializePaymentAndValidate);
  }

  async function handleApplyPaymentEntry(query: IPaymentDetailFacade): Promise<void> {
    const response = await onProcessPaymentAndValidate(query);
    if (!response.Status || !response.ProcessPaymentDetail) {
      showSnackBar({ variant: 'error', message: 'Failed to process payment.' });

      return;
    }

    onApply(response);
  }

  return (
    <React.Fragment>
      <PaymentEntryDialog
        open={open}
        module={module}
        initialValues={initialPaymentEntryValues}
        onCancel={async () => { onCancel(); }}
        onAddNewPaymentLine={onAddNewPaymentLine}
        onCalculatePaymentLineDetails={onCalculatePaymentLineDetails}
        onUpdatePaymentLineDetails={onUpdatePaymentLineDetails}
        onDeletePaymentLine={onDeletePaymentLine}
        onCalculatePaymentAmount={onCalculatePaymentAmount}
        onApply={handleApplyPaymentEntry}
        changeConfirmationDialog={changeConfirmationDialog}
      />
    </React.Fragment>);
}

export default PaymentEntry;
